const authorProfile = [
  {
    id: 1,
    profileImg:
      "https://s3-alpha-sig.figma.com/img/881e/f4d1/cf3d8002edf27868571c9eb61e93a3ad?Expires=1717977600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=X7l~DW6gf5brkYvabmTVNYmEJHOhoEyAudWLP7aBJOuXItV6BgJTZ0uKxriwfQPA1IQ4NI3oGsyLASFp0x1g5-OGdx~rDWQoKdW16-bVcA2vdS-74KcQYs1uFJzUBFpCZW3s-eGiPuuDEQXYuqGdoj0lMYl8YRzXsHx9jkTHq4liI8SlzL~i04sm112BwCaef0BNQAKfMGLBBHqEm8FYgS50CuPBDOHQhKVUMYij6dTXAHtUBaTaX0TJApeztoSePQ1PKWIxTzNtgX-U8823FqsMGbR6zJJOwMvmuu3ky2I4jeKdQteW3i2hjVDTeUd-2~U9w-ZKTVppepbLL3wWmw__",
    author: "Adrian Chiran",
    about:
      "UX/Product Designer with experience in leading design, crafting products, and shaping experiences across multiple industries. Bachelor's degree in Computer Science, previously Staff Designer at Adobe.",
    link: "#",
    work: [
      { id: 1, price: 45, title: "Savory Food UI Kit" },
      { id: 2, price: 45, title: "Savory Food UI Kit" },
      { id: 4, price: 45, title: "Savory Food UI Kit" },
      { id: 5, price: 45, title: "Savory Food UI Kit" },
      { id: 6, price: 45, title: "Savory Food UI Kit" },
      { id: 7, price: 45, title: "Savory Food UI Kit" },
    ],
  },
];

export default authorProfile;
